<template>
    <div class="card">

        <div class="card-header border-0">
            <div class="row">
                <div class="col-6">
                    <h3 class="mb-0 text-uppercase">{{ cohort.name }}</h3>
                </div>
                <div class="col-6 text-right">
                    <button-radio-group 
                        :options="roleOptions"
                        button-classes="btn-secondary btn-sm"
                        v-model="role"
                        class="d-inline">
                    </button-radio-group>
                </div>
            </div>
        </div>

        <learners
            :cohort="cohort"
            :learners="learners"
            v-if="learners && role == 'learner'">
        </learners>

        <instructors
            :cohort="cohort"
            :instructors="instructors"
            v-if="instructors && role == 'instructor'"
            @change="$emit('change')">
        </instructors>

    </div>
</template>

<script>
    import Learners from './Learners'
    import Instructors from './Instructors'

    export default {

        components: {
            Learners, Instructors
        },

        props: {

            cohort: {
                type: Object,
                required: true
            },

            learners: {
                type: Array,
            },

            instructors: {
                type: Array,
            },
        },

        data() {
            return {
                role: this.$route.params.role ? this.$route.params.role : 'learner',
            }
        },

        computed: {

            roleOptions() {
                return [
                    { value: 'learner', label: this.$t('common.learners') },
                    { value: 'instructor', label: this.$t('common.instructors') },
                ]
            },
        },
    }
</script>
